import { type FC, useState } from 'react';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';
import {
  Inline,
  TextLink,
  Text,
  IconCopy,
  ButtonIcon,
  IconTick,
} from 'braid-design-system';
import { linkPropsWithKeyboardNavigation } from 'src/utils/buildHandleEnterAndSpaceKeyPress';

interface Props {
  label: string;
  copyButton: {
    id: string;
    label: string;
  };
  href: string;
  contactValue: string;
  onContactClick: () => void;
  onCopyClick: () => void;
}

export const ContactInfo: FC<Props> = ({
  label,
  copyButton,
  href,
  contactValue,
  onContactClick,
  onCopyClick,
}) => {
  const { t } = useTranslations(translations);
  const [copySuccess, setCopySuccess] = useState(false);

  const copy = (stringToCopy: string) => {
    // FIX ME: only works in https environment
    navigator.clipboard
      .writeText(stringToCopy)
      .then(() => {
        setCopySuccess(true);
        onCopyClick();
        setTimeout(() => {
          setCopySuccess(false);
        }, 10000);
      })
      .catch();
  };

  return (
    <Inline space="small" alignY="center">
      <Text>
        <TextLink
          href={href}
          onClick={onContactClick}
          aria-label={label}
          data={{
            'hj-masked': true,
          }}
        >
          {contactValue}
        </TextLink>
      </Text>
      <ButtonIcon
        id={copyButton.id}
        label={!copySuccess ? copyButton.label : t('Copied')}
        variant="transparent"
        bleed
        icon={
          !copySuccess ? (
            <IconCopy tone="secondary" />
          ) : (
            <IconTick tone="positive" />
          )
        }
        {...linkPropsWithKeyboardNavigation(() => copy(contactValue))}
        onClick={() => {
          if (!copySuccess) {
            copy(contactValue);
          }
        }}
      />
    </Inline>
  );
};
